import { mergeTypographyStyles } from '../utils.js';
import { opalBase } from './base.js';
// Geist has custom letter spacing in Opal
export const geist = mergeTypographyStyles(opalBase, {
    title5xl: {
        letterSpacing: -0.0625,
    },
    title4xl: {
        letterSpacing: -0.0625,
    },
    title3xl: {
        letterSpacing: -0.0625,
    },
    title2xl: {
        letterSpacing: -0.0625,
    },
    titleXl: {
        letterSpacing: -0.015625,
    },
    titleLg: {
        letterSpacing: -0.015625,
    },
});
//# sourceMappingURL=geist.js.map